
<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_254_1961)">
      <path
        d="M7.01562 5.54541C7.01649 5.54602 7.01675 5.54725 7.01758 5.54834C7.01844
        5.54948 7.02136 5.55195 7.02344 5.55811L7.58789 7.25342C7.72645 7.66891
        7.95974 8.04633 8.26953 8.35596C8.57928 8.66553 8.95657 8.89926 9.37207
        9.0376L11.0664 9.60205C11.0728 9.60419 11.076 9.6061 11.0771
        9.60693C11.0782 9.60779 11.0785 9.60895 11.0791 9.60986C11.0806
        9.61214 11.083 9.61749 11.083 9.62549C11.0829 9.63334 11.0806 9.63889
        11.0791 9.64111C11.0786 9.64182 11.078 9.64239 11.0771 9.64307L11.0664 9.64893L9.37109
        10.2134C8.95572 10.352 8.5781 10.5853 8.26855 10.895C7.9591 11.2047 7.72621 11.5822
        7.58789 11.9976L7.02344 13.6919L7.02246 13.6929C7.02087 13.6977 7.0178 13.7026 7.01367
        13.7056C7.00969 13.7083 7.00485 13.7094 7 13.7095C6.99494 13.7095 6.98946 13.7085 6.98535
        13.7056C6.98122 13.7026 6.97815 13.6977 6.97656 13.6929V13.6919L6.41211 11.9966C6.27364
        11.5812 6.04005 11.2036 5.73047 10.894C5.45962 10.6232 5.13687 10.4107 4.78223 10.269L4.62793
        10.2134L2.93262 9.64893L2.93164 9.64795C2.92688 9.64634 2.92287 9.64323 2.91992 9.63916C2.91701
        9.63513 2.91511 9.63045 2.91504 9.62549C2.91504 9.62039 2.91693 9.61497 2.91992 9.61084C2.92289
        9.60682 2.9269 9.60363 2.93164 9.60205H2.93262L4.62793 9.0376C5.04336 8.89915 5.42082 8.66559
        5.73047 8.35596C6.04012 8.04631 6.27365 7.66886 6.41211 7.25342L6.97656 5.55811C6.97851
        5.55239 6.98053 5.5496 6.98145 5.54834C6.98234 5.54716 6.98342 5.54606 6.98438 5.54541C6.98673
        5.54388 6.99216 5.5415 7 5.5415C7.00788 5.54156 7.01339 5.5439 7.01562 5.54541ZM3.74219 2.11377C3.9226
        2.6539 4.34563 3.07785 4.88574 3.2583H4.88672L5.61426 3.49951L4.88672 3.74268C4.62021 3.83147 4.37735
        3.98056 4.17871 4.1792C3.98022 4.3777 3.831 4.61994 3.74219 4.88623V4.88721L3.49902 5.61475L3.25781
        4.88721V4.88623C3.169 4.61986 3.01886 4.37775 2.82031 4.1792C2.62176 3.98071 2.37963 3.83145 2.11328
        3.74268L1.38477 3.49951L2.11328 3.2583C2.37977 3.16951 2.62169 3.01942 2.82031 2.8208C3.01893
        2.62218 3.16902 2.38025 3.25781 2.11377L3.49902 1.38525L3.74219 2.11377ZM9.69336
        0.855957C9.82296 1.24589 10.1287 1.55146 10.5186 1.68115L10.7246 1.74951L10.5186
        1.81885C10.3264 1.8828 10.152 1.99107 10.0088 2.13428C9.86558 2.2775 9.7573 2.45187
        9.69336 2.64404L9.62402 2.8501L9.55566 2.64404C9.49176 2.45204 9.38425 2.27741
        9.24121 2.13428C9.09797 1.99103 8.92269 1.88279 8.73047 1.81885L8.52441 1.74951L8.73145
        1.68115C9.12146 1.55151 9.42701 1.24598 9.55664 0.855957L9.62402 0.649902L9.69336 0.855957Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.583333"
      />
    </g>
    <defs>
      <clipPath id="clip0_254_1961">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>